// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1_fS6","cls2":"ImpactHubModal-cls2_nb_ ImpactHubModal-cls1_fS6"};